import { GetCatalogProductViewQuery } from '@notino/shared/definitions/types';

import { useProductDetailContext } from '@containers/ProductDetailContainer/ProductDetailContext';
import { useFeatureFlags } from '@context/featureFlags/FeatureFlagsProvider';
import { useApolloClientHeaders } from '@hooks/useApolloClientHeaders';

import { SkinAnalyzerConfig } from '../models';

export const useIsSkinAnalyzerVisible = () => {
  const ctx = useProductDetailContext(false);
  const { pd_skin_analyzer_config } = useFeatureFlags();
  const { shopId } = useApolloClientHeaders();

  if (!ctx) {
    return false;
  }

  return getIsSkinAnalyzerVisible({
    product: ctx.product,
    pd_skin_analyzer_config,
    shopId,
  });
};

export const getIsSkinAnalyzerVisible = ({
  product,
  pd_skin_analyzer_config,
  shopId,
}: {
  product: GetCatalogProductViewQuery['productDetailByCatalogMasterId'];
  pd_skin_analyzer_config: SkinAnalyzerConfig;
  shopId: string;
}) => {
  if (!product || !pd_skin_analyzer_config) {
    return false;
  }

  if (!pd_skin_analyzer_config.countryConfig[shopId]) {
    return;
  }

  const productBrandId = Number(product.brand?.id);
  const brandData = pd_skin_analyzer_config[productBrandId];

  if (!brandData) {
    return false;
  }

  const { allowedCategoryIds } = brandData;

  const productCategoryIds =
    product.categorization?.categories?.map(({ id }) => Number(id)) ?? [];

  return productCategoryIds.some((id) => allowedCategoryIds.includes(id));
};
